var App = App || {};

App.Alerts = (() => {
    const init = () => {
        document.querySelectorAll('.site-alert').forEach(alert => {
            const closeButton = alert.querySelector('.site-alert__close');
            closeButton.addEventListener('click', (e) => {
                e.preventDefault();
                dismiss(alert);
            });
        });
    };

    const dismiss = (alert) => {
        alert.classList.add('site-alert--dismissed');
        alert.addEventListener('transitionend', () => {
            afterDismissed(alert);
        }, { once: true });
        App.Cookies.setItem(
            `AlertDismissed-${alert.dataset.alertid}`,
            'true',
            Infinity,
            '/',
            window.location.hostname,
            window.location.protocol === 'https:'
        );
    };

    const afterDismissed = (alert) => {
        alert.remove();
    };

    return {
        init,
    };
})();